import { QRCode as AntQRCode, QRCodeProps } from 'antd'

const QRCode = (props: QRCodeProps) => {
    return <AntQRCode bgColor="white" {...props} />
}

export default QRCode
